module.exports = __webpack_public_path__ + "static/media/icon-edit.c82a70f7.svg";